var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field',{attrs:{"field":_vm.formField,"readonly":false,"validations":_vm.validations},on:{"fieldChange":_vm.fieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }